import { Container } from "aurelia-dependency-injection";
import AuthService from "../services/auth.service";
import moment from "moment";
import { MessageService } from "../services/message-service";
import { ISetUserProfile } from "../resources-vue/vue-interfaces/messaging-service/i-user";
import { ProfileActivityStatusEnum } from "../enums/ChatUserProfileEnum";
import { useApp } from "../pages-vue/App/useApp";
import eventBus from "../utilities/eventBus";

import idleTimeout from "../resources-vue/vue-dialogs/IdleTimeout/IdleTimeout.vue";

export default class {
    public _auth: AuthService;
    public _messageService: MessageService;
    public _allowedIdleTime: number = 30;
    public idleWarningTimeInMinutes: number = 5;
    public isIdleWarningOpen: boolean = false;
    public idleInterval: any;
    public logoutTimer: any;
    public dialogRef: any;
    private appStore: any;
    private inactivityTimeInMinutes: number = 10;
    private updatedInactivityStatus: boolean = false;

    public constructor() {
        this._auth = Container.instance.get(AuthService);
        this._messageService = Container.instance.get(MessageService);
        this.appStore = useApp();
        this.resetIdleTime();
    }

    public async timer(dialogReference: any) {
        this.idleInterval = setInterval(async () => {
            await this.checkIdleTime(dialogReference);
        }, 1000); // 1 second

        $(window)
            .mousemove(
                this.debounce(() => {
                    this.resetIdleExpiryTime();
                }, 500)
            )

            .click(
                this.debounce(() => {
                    this.resetIdleExpiryTime();
                }, 500)
            );
    }

    public async stopIdleTimer() {
        clearInterval(this.idleInterval);
        $(window).off("mousemove").off("click");
    }

    private async checkIdleTime(dialogReference: any) {
        let idleTime = JSON.parse(localStorage.getItem("idleExpiry"));
        let a = moment(idleTime);
        let b = moment();
        let difference = a.diff(b, "s");

        if (difference > 0) {
            const minutes = (difference / 60) | 0;
            const totalInactivityTime = this._allowedIdleTime - this.inactivityTimeInMinutes;
            // user is marked as inactive/away after 10 mins of inactivity
            if (minutes < totalInactivityTime && !this.updatedInactivityStatus) {
                this.updatedInactivityStatus = true;
                const payload: ISetUserProfile = {
                    login: this.appStore.loggedInUserDetails.loginId,
                    userActivityStatus: ProfileActivityStatusEnum.InActive
                };
                await this._messageService.updateUserProfile(payload);
                eventBus.emit("updateUserStatus");
            }
            if (difference <= this.idleWarningTimeInMinutes * 60) {
                if (!this.isIdleWarningOpen) {
                    this.isIdleWarningOpen = true;

                    this.dialogRef = dialogReference.open(idleTimeout, {
                        props: {
                            modal: true,
                            showHeader: false
                        },
                        data: {
                            idleWarningTimeInMinutes: this.idleWarningTimeInMinutes
                        },
                        onClose: (options: any) => {
                            if (options.data === "success") {
                                this.resetIdleTime();
                                this.isIdleWarningOpen = false;
                            } else {
                                this._auth.logout();
                            }
                        }
                    });
                }
            } else {
                this.isIdleWarningOpen = false;
            }
        }
    }

    public debounce(fn: () => void, delay: number): () => void {
        this.logoutTimer = null;
        return () => {
            clearTimeout(this.logoutTimer);
            this.logoutTimer = setTimeout(() => {
                fn();
            }, delay);
        };
    }

    public async resetIdleTime() {
        if (this.updatedInactivityStatus) {
            const payload: ISetUserProfile = {
                login: this.appStore.loggedInUserDetails.loginId,
                userActivityStatus: ProfileActivityStatusEnum.ResetActivity
            };
            await this._messageService.updateUserProfile(payload);
            eventBus.emit("updateUserStatus");
            this.updatedInactivityStatus = false;
        }
        localStorage.setItem("idleExpiry", JSON.stringify(moment().add(this._allowedIdleTime, "m")));
    }

    public resetIdleExpiryTime() {
        let idleTime = JSON.parse(localStorage.getItem("idleExpiry"));
        let a = moment(idleTime);
        let b = moment();
        let difference = a.diff(b, "s");

        if (difference > this.idleWarningTimeInMinutes * 60) {
            this.resetIdleTime();
        }
    }
}
